import React from 'react'
import { useObserver } from 'mobx-react-lite'
import { stores, strings } from '@stores'
import { clientSearchManagementService } from '@services/wholesale/clientSearchManagementService'
import { clientSearchTableViewDefinitionService } from '@services/wholesale/clientSearchTableViewDefinitionService'
import { StandardSearchView } from '@components/UI-Components/StandardClusterView/components/StandardSearchView'
import { useTranslation } from 'react-i18next'

interface ClientSearchProps {
  zones?: Array<any>
  clientData?: any
  onClientSelect?: any
  allowMultiSelect?: boolean
  setSelectedData?: any
  maxSelectionLimit?: number
  isActionAllowed?: boolean
  handleSubmit?: any
  isActionInProcess?: boolean
  isActionDisabled?: boolean
  columnWidth?: number
  showCountDetails?: boolean
  canSelectAll?: boolean
  selectedRows?: any
  disabledRows?: any[]
  columnDefs?: any[]
  showAllFilter?: boolean
}

const TABLEROWHEIGHT = 32
const HEADERHEIGHT = 40
const SEARCHCONTAINERHEIGHT = 571
const SEARCHCONTAINERWIDTH = 541

export const ClientSearch: React.FunctionComponent<ClientSearchProps> = ({
  clientData,
  onClientSelect,
  zones,
  allowMultiSelect,
  setSelectedData,
  maxSelectionLimit,
  isActionAllowed,
  handleSubmit,
  isActionInProcess,
  isActionDisabled,
  columnWidth,
  showCountDetails,
  canSelectAll,
  selectedRows,
  disabledRows,
  columnDefs,
  showAllFilter
}) => {
  return useObserver(function useHook() {
    const {
      clientSearch: { anchorEl, handlePopOverClose },
      nav: {
        queryParams: { assortmentType }
      }
    } = stores

    const { t } = useTranslation()

    const columnDef =
      columnDefs ||
      clientSearchTableViewDefinitionService.buildTableViewDefinitionForClientSearch(
        onClientSelect,
        columnWidth
      )

    const [zoneID, setZoneID] = React.useState(null)
    const [zoneName, setZoneName] = React.useState(null)

    React.useEffect(() => {
      if (!zones || !zones.length) return
      // set default values
      !zoneID && setZoneID(zones[0]?.Id)
      !zoneName && setZoneName(zones[0]?.Name)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zones])

    const zoneMap = React.useMemo(() => {
      return zones?.map(obj => {
        return {
          ...obj,
          name:
            obj.Id === strings.worldWide
              ? t('bb.bsgSetting.SubHeader.worldwide', 'Worldwide')
              : obj?.Name,
          id: obj?.Id
        }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zones])

    const handleHeaderSelection = event => {
      const id = event?.target?.value
      const name = zones?.find(obj => obj?.Id === id)?.Name
      setZoneID(id)
      setZoneName(name)
    }

    // Process response and filter result for selected zone
    let processedClientData = clientSearchManagementService.processAndFilterClientData(
      {
        clients: clientData
      } as any,
      zoneName
    )

    return (
      <React.Fragment>
        <StandardSearchView
          showAllFilter={showAllFilter}
          isUpperCase={true}
          headerData={zoneMap}
          onHeaderDataSelect={handleHeaderSelection}
          selectedHeaderId={zoneID}
          anchorEl={anchorEl}
          handleClose={handlePopOverClose}
          columnDef={columnDef}
          processedData={processedClientData}
          tableRowHeight={TABLEROWHEIGHT}
          headerHeight={HEADERHEIGHT}
          searchContainerHeight={SEARCHCONTAINERHEIGHT}
          searchContainerWidth={SEARCHCONTAINERWIDTH}
          allowMultiSelect={allowMultiSelect && processedClientData.length > 0}
          setSelectedData={setSelectedData}
          maxSelectionLimit={clientData?.length || maxSelectionLimit}
          isActionAllowed={isActionAllowed}
          handleSubmit={handleSubmit}
          isActionInProcess={isActionInProcess}
          isActionDisabled={assortmentType ? true : isActionDisabled}
          showCountDetails={showCountDetails}
          canSelectAll={canSelectAll}
          selectedRows={selectedRows}
          disabledRows={assortmentType ? processedClientData : disabledRows}
        />
      </React.Fragment>
    )
  })
}
